import {
  SET_STUDENT_CERTIFICATION_LIST,
  SET_STUDENT_CERTIFICATION_LIST_PAGE,
  SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE,
  SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE_TOTAL,
  SET_STUDENT_CERTIFICATION_QUERY,
  SET_STUDENT_CERTIFICATION_STATUS,
  SET_STUDENT_CERTIFICATION_REMARKS,
  SET_STUDENT_CERTIFICATION_IMAGE,
  SET_STUDENT_CERTIFICATION_SEARCHING,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'
import { checkUserName } from '@/views/User/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  userName: '',
  startTime: '',
  endTime: '',
  status: '',       // int 验证状态(0未验证1验证中2已通过3已驳回)
})
const state = {
  searching: false,
  initQuery: initQuery(),
  studentCertifications: {
    list: [],
    // listCurrentPage: 1,
    listPageTotal: 0,
    // listPageSize: 50,
    query: initQuery(),
  },
  status: 0,
  remarks: '',
  imgSrcs: [],
}
const mutations = {
  [SET_STUDENT_CERTIFICATION_LIST] (state, payload) {
    state.studentCertifications.list = payload
  },
  [SET_STUDENT_CERTIFICATION_LIST_PAGE] (state, payload) {
    state.studentCertifications.query.pageNum = payload
  },
  [SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE] (state, payload) {
    state.studentCertifications.query.pageSize = payload
  },
  [SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE_TOTAL] (state, payload) {
    state.studentCertifications.listPageTotal = payload
  },
  [SET_STUDENT_CERTIFICATION_QUERY] (state, payload) {
    state.studentCertifications.query = {
      ...state.studentCertifications.query,
      ...payload,
    }
  },
  [SET_STUDENT_CERTIFICATION_STATUS] (state, payload) {
    state.status = payload
  },
  [SET_STUDENT_CERTIFICATION_REMARKS] (state, payload) {
    state.remarks = payload
  },
  [SET_STUDENT_CERTIFICATION_IMAGE] (state, payload) {
    state.imgSrcs = payload
  },
  [SET_STUDENT_CERTIFICATION_SEARCHING] (state, payload) {
    state.searching = payload
  },
}
const actions = {
  async setStudentCertificationList ({commit, state, dispatch}, payload) {
    try {
      let query = {}
      _.forIn(state.studentCertifications.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageSize: state.studentCertifications.query.pageSize,
        pageNum: state.studentCertifications.query.pageNum,
        ...payload,
      }
      if (payload && !payload.userName && params.userName) {
        delete params.userName
      }
      const {data, code} = await api.userApi.queryStudentAuthens(params)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = params
          dispatch('setStudentCertificationList', {
            ...other,
            userId,
          })
        },
      })
      const {items, total} = data
      commit(SET_STUDENT_CERTIFICATION_SEARCHING, false)
      commit(SET_STUDENT_CERTIFICATION_LIST, items)
      commit(SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE_TOTAL, total)
    } catch (error) {
      commit(SET_STUDENT_CERTIFICATION_LIST, [])
      commit(SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE_TOTAL, 0)
    }
  },
  async changeListPage ({commit, state, dispatch}, payload) {
    commit(SET_STUDENT_CERTIFICATION_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setStudentCertificationList')
  },
  initStudentCertificationList ({commit, dispatch}, payload) {
    let query = initQuery()
    commit(SET_STUDENT_CERTIFICATION_QUERY, query)
    dispatch('changeListPage', {currentPage: 1})
  },
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_STUDENT_CERTIFICATION_SEARCHING, true)
    commit(SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeListPage', {currentPage: 1})
  },
  changeQuery ({commit, dispatch}, payload) {
    commit(SET_STUDENT_CERTIFICATION_QUERY, payload)
  },
  async changeStatus ({commit}, payload) {
    const {code} = await api.userApi.changeStudentAuthenStatus(payload)
    if (code === 200) {
      commit(SET_STUDENT_CERTIFICATION_STATUS, payload.status)
      commit(SET_STUDENT_CERTIFICATION_REMARKS, payload.remarks)
    }
    return code
  },
  async checkDetails ({commit}, payload) {
    const {data: {identitycardFrontImage, identitycardBehindImage, studentCardImage}} = await api.userApi.queryStudentAuthenDetail(payload)
    commit(SET_STUDENT_CERTIFICATION_IMAGE, [identitycardFrontImage, identitycardBehindImage, studentCardImage])
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
